"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdibleFungi = void 0;
var Tags_1 = require("../../Tags");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRequirements_1 = require("../../CardRequirements");
var EdibleFungi = (function (_super) {
    __extends(EdibleFungi, _super);
    function EdibleFungi() {
        return _super.call(this, {
            cost: 12,
            tags: [Tags_1.Tags.MICROBE],
            name: CardName_1.CardName.EDIBLE_FUNGI,
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.MICROBE, 1); }),
            metadata: {
                cardNumber: 'L403',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(2); });
                }),
                description: 'Requires 1 Microbe tag. Increase your Plant production 2 steps.',
            },
        }) || this;
    }
    EdibleFungi.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    };
    return EdibleFungi;
}(Card_1.Card));
exports.EdibleFungi = EdibleFungi;
//# sourceMappingURL=EdibleFungi.js.map